import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapLanguages = React.lazy(function () { return import('../../bootstrap-components/components/BTLanguages'); });
var bootStrapLanguages = function (props) {
    return (React.createElement(BootStrapLanguages, __assign({}, props)));
};
export var Languages = function (props) {
    var componentToDisplay = bootStrapLanguages(props);
    return (React.createElement("div", null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Languages.defaultProps = {
    defaultlanguage: 'English'
};
export default Languages;
//# sourceMappingURL=Languages.js.map